var t = function(r, o) {
  try {
    arguments.length === 1 ? console.error(r) : console.error(r, o);
  } catch {
  }
};
export {
  t as h
};
